import { Input, Label } from '@up2stay/up2promo-ui';

import { SettingsInfoHint } from '@/core/components/settings/settings-info-hint';

export type ProductFormDescriptionFieldProps = {
  id: string;
  value: string;
  onChange: (v: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  label?: string;
  placeholder?: string;
  hint?: string;
  requiredMessage?: string;
  /** When false, omit the required asterisk (setup wizard). Default true. */
  required?: boolean;
  autoFocus?: boolean;
};

export function ProductFormDescriptionField({
  id,
  value,
  onChange,
  onBlur,
  onFocus,
  label,
  placeholder,
  hint,
  requiredMessage,
  required = true,
  autoFocus,
}: ProductFormDescriptionFieldProps) {
  return (
    <div className="space-y-0.5 min-w-0 w-full">
      <div className="flex items-center gap-0.5">
        <Label htmlFor={id}>
          {label}
          {required ? <span className="text-destructive"> *</span> : null}
        </Label>
        {hint ? (
          <SettingsInfoHint label={label ?? 'Description'}>
            {hint}
          </SettingsInfoHint>
        ) : null}
      </div>
      <Input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        autoFocus={autoFocus}
      />
      {requiredMessage ? (
        <p className="text-xs text-destructive">{requiredMessage}</p>
      ) : null}
    </div>
  );
}
